
<template>
  <div 
    v-if="isAdmin"
    class="explorer-header-check-templates"
  >
    <v-menu 
        offset-y
    >
        <template v-slot:activator="{ on }">
          <v-btn 
            rounded
            depressed
            v-on="on"
            icon
            class="explorer-header-report-list"
            :medium="!is_mobile" :small="is_mobile"
          >
            <v-icon :medium="!is_mobile" :small="is_mobile" color="primary"> mdi-paperclip </v-icon>
          </v-btn>
        </template>
        <v-list dense>
            <v-list-item
                v-for="doc in items"
                :key="doc.id"
                @click.stop="open(doc)"
            >
            <v-list-item-title style="display: block;">{{ doc.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-menu>

    <ModalDialog
      small
      v-if="selected"
      :title="selected.name"
      :showModalDialog="show_dialog"
      :fields_to_collect="modal[selected.id]"
      :submit_button_text="$vuetify.lang.translator('dialog.send')"
      validate
      @close-dialog="close"
      @submit="setTemplate"
    >
    </ModalDialog>

    <!--<v-btn
      v-if="isAdmin"
      rounded
      depressed
      @click="show_dialog = true"
      icon
      class="explorer-header-report-list"
    >
      <v-icon medium> mdi-paperclip </v-icon>
      <input
        ref="uploader"
        class="d-none"
        type="file"
        accept="*.xlsx"
        @change="onFileChanged"
      />
    </v-btn>-->
    
  </div>
</template>
  
<style lang="scss">
@import "@/sass/explorer.scss";
  .explorer-header-check-templates {
   width: fit-content;
   display: inline-flex;
  }
</style>
  
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { downloadFile } from '@/utils/browserfiles'
import QReport from '@/api/QReportsItem'
import QUnitCollection from '@/qunit/QUnitCollection';
import DynamicForm from '@/components/DynamicForm'
import ModalDialog from '@/components/explorer/ModalDialog'

export default {
  name: 'CheckTemplate',

  components: {
    DynamicForm,
    ModalDialog
  },
  props: {
      filters: {},
      qunits: {type: QUnitCollection},
      is_mobile: {type: Boolean, default: false},
  },

  data() { 
    return {
      file: null,
      isSelecting: false,
      selected: null,
      valid: false,

      show_dialog: false,
    }
  },

  computed: {
    ...mapGetters([
       'isAdmin',
       'centro_id',
     ]),

    computed_units() {
    return (this.qunits.units || []).map(unit => ([unit.uid,unit.reference/*+' | '+(unit.title || '')*/]));
    },

    modal() {
      return {
        'docx' : [
          [{
            component: "Select",
            id: "unit",
            label: this.$vuetify.lang.translator('labels.document'),
            required: true,
            items: this.computed_units,
            disabled: !this.qunits || this.qunits.count <= 0,
          }],
          [{
            component: "FileInput",
            id: "template",
            label: this.$vuetify.lang.translator('labels.report'),
            file_type: ["docx"],
            required: true,
          },]
        ],
        'xlsx' : [
          [{
            component: "FileInput",
            id: "template",
            label: this.$vuetify.lang.translator('labels.report_list'),
            file_type: ["xlsx","xls"],
            required: true,
          },]
        ],
      }
    },

    items() {
      return [
        {id: 'docx', name: this.$vuetify.lang.translator('labels.report') + ' (docx)'},
        {id: 'xlsx', name: this.$vuetify.lang.translator('labels.report_list') + ' (xlsx)'}]
    },
  },


  methods: {
    setTemplate(data) {
      const items_selected = Object.fromEntries(data.entries())
      if (this.selected.id == 'docx') {
        this.printCustomReport(items_selected.unit,items_selected.template);
      } else if (this.selected.id == 'xlsx') {
        this.download_list_customed_report(items_selected.template);
      } else {
        console.error('Something went wrong');
      }
      this.close();
    },
    open(item) {
      this.selected = item;
      this.show_dialog = true;
    },
    close() {
       this.show_dialog = false;
     },

    download_list_customed_report(template_file){
      //console.error('Error: Selected file extension is not supported')
      let name = "Listado personalizado de no conformidad"
      QReport.printListCustomTemplate(
        this.centro_id,
        this.filters,
        template_file,
      ).then(data => {
        let f_name = name + '.xlsx';
        // TODO: HARDCODDED xlsx
        downloadFile(data, f_name)
      }).catch(error => 
        console.error(error)
      );
    },

    printCustomReport(item_id, template_file){
      // TODO:
      const item = this.qunits.units.find(element => element.uid == item_id);
      QReport.printQUnitCustomTemplate(
        this.centro_id,
        item.uid,
        template_file
      ).then(data => {
        let f_name = item.title + '.docx'
        downloadFile(data, f_name)
      }).catch(error => 
        console.error(error)
      )
    },
    /*onFileChanged(e) {
      this.file = e.target.files[0]
      if(this.file.name.endsWith('xls') || this.file.name.endsWith('xlsx')) {
        this.download_list_customed_report(this.file)
      } else {
        console.error('Error: Selected file extension is not supported')
      }
    },*/
  },
}
</script>
  